import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const MyPreset = definePreset(Aura, {
  primitive: {
    bluegray: {
      50: '#f3f4f6',
      100: '#e2e8f0',
      200: '#bcc3cd',
      300: '#9fa9b7',
      400: '#818ea1',
      500: '#64748b',
      600: '#556376',
      700: '#465161',
      800: '#37404c',
      900: '#282e38',
      950: '#1f2937',
    },
    blue: {
      50: '#cbd5e1',
      100: '#d0e1fd',
      200: '#abc9fb',
      300: '#85b2f9',
      400: '#0ea5e9',
      500: '#3b82f6',
      600: '#326fd1',
      700: '#295bac',
      800: '#204887',
      900: '#183462',
      950: '#0f2747',
    },
  },
  semantic: {
    primary: {
      0: '#ffffff',
      50: '#f0f9ff',
      100: '#e0f2fe',
      200: '#bae6fd',
      300: '#7dd3fc',
      400: '#38bdf8',
      500: '#0ea5e9', // 🔵 primary หลักของคุณ
      600: '#0284c7',
      700: '#0369a1',
      800: '#075985',
      900: '#0c4a6e',
      950: '#082f49',
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '#f7f7f7',
          100: '#efefef',
          200: '#e7e7e7',
          300: '#e4e4e4',
          400: '#cfcfcf',
          500: '#475569',
          600: '#3f4854',
          700: '#333a44',
          800: '#272d36',
          900: '#1a1f27',
          950: '#0f1319',
        },
      },
      dark: {
        surface: {
          0: '#1f2937', // darkest background
          50: '#273244',
          100: '#363d47',
          200: '#4b5563',
          300: '#6b7280',
          400: '#8a94a3',
          500: '#9ca3af',
          600: '#b4bac3',
          700: '#c7ced6',
          800: '#dbe1e7',
          900: '#edf1f5',
          950: '#ffffff',
        },
      },
    },
  },
  components: {},
});

export default MyPreset;
